<template>
    <DialogSelectStation v-model="dialog">
        <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" :disabled="!can_select_station">
                <template v-slot:prepend>
                    <v-icon> mdi-toolbox </v-icon>
                </template>
                <v-list-item-title>
                    {{ t("change_station") }}
                </v-list-item-title>
            </v-list-item>
        </template>
    </DialogSelectStation>
</template>

<script>
import { useSessionStore } from "@/stores/session";
import { useTranslationsStore } from "@/stores/translations";
import DialogSelectStation from "./DialogSelectStation.vue"

export default {
    components: {
        DialogSelectStation,
    },
    emits: ["close"],
    setup() {
        const session_store = useSessionStore()
        const translations_store = useTranslationsStore()
        const t = translations_store.translate
        return {
            session_store,
            t,
        }
    },
    data: () => ({
        dialog: false,
    }),
    computed: {
        can_select_station() {
            return this.session_store.user_object?.auth
                ?.can_select_station;
        },
    },
    watch: {
        dialog(d) {
            if (!d) this.$emit("close");
        },
    },
};
</script>
